<template>
  <div class="d-flex flex-column">
    <div class="top-header">
      <router-link :to="{ name: 'admins_accounts' }">
        <v-btn icon>
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </router-link>
      {{ admin.name }}
    </div>

    <v-sheet class="py-5 px-8">
      <div class="top-header">{{ $t("EditAdmin") }}</div>
      <v-divider class="my-4 divider-dashed" />

      <v-tabs v-model="tab" class="d-none">
        <v-tab class="text-capitalize"></v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <EditAdmin :adminProp="admin" />
        </v-tab-item>
      </v-tabs-items>
    </v-sheet>
  </div>
</template>

<script>
import RestResourceAdmin from "@/api/apiAdminService";
import EditAdmin from "./EditAdmin";
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export default {
  components: { EditAdmin },
  data() {
    return {
      admin: {
        name: ""
      },
      tab: null
    };
  },
  created() {
    this.initialize();
  },
  methods: {
    initialize() {
      RestResourceAdmin.prototype
        .getAdmin(this.$route.params.id)
        .then(response => {
          this.admin = response.data;
        })
        .catch(error => {
          throw error;
        });
    }
  }
};
</script>
